import React from 'react'
import SEO from "../../components/seo";

import Layout from '../../components/layout'
import ServicesPage from '../../components/PageComponents/Treatments/neckBackPain/ServicesPage'


const Services = () => (
    <Layout>
    
        <SEO title="Neck and Back Pain" />

        <ServicesPage />

    </Layout>
)

export default Services